import { render, staticRenderFns } from "./magazine.vue?vue&type=template&id=08330f62&"
var script = {}
import style0 from "./magazine.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08330f62')) {
      api.createRecord('08330f62', component.options)
    } else {
      api.reload('08330f62', component.options)
    }
    module.hot.accept("./magazine.vue?vue&type=template&id=08330f62&", function () {
      api.rerender('08330f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/magazine/magazine.vue"
export default component.exports